import React from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import i18n from 'i18n-js';

// Locales
import 'moment/locale/da';
import 'moment/locale/nn';
import 'moment/locale/sv';

type CalendarType = {
  notAvailable?: any;
  selectDate?: (val: string) => void;
  notAvailableArray?: [];
  day?: object;
  getDate ?: any;
  date?: string;
  weekDay?: object;
  className?: string,
  // localeUtils?: any,
  localeUtils?: {formatWeekdayLong: (weekday: number, locale: string) => void};
  weekday?: number;
  locale?: string;
  dateFrom?: string;
  dateTo?: string;
  dataArrow?: object;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  isTo?: boolean;
}

const navbarElement = (dataArrow: CalendarType) => {
  const {
    onPreviousClick,
    onNextClick,
    className,
  } = dataArrow;

  return (
    <div className={className}>
      <button className="left-arrow" onClick={() => onPreviousClick()}>
        &lt;
      </button>
      <button className="right-arrow" onClick={() => onNextClick()}>
        &gt;
      </button>
    </div>
  );
}

// const weekdayElement = (weekDay: CalendarType) => {
//   const { className, localeUtils, weekday, locale } = weekDay;
//   const weekdayName: any = localeUtils.formatWeekdayLong(weekday, locale);
//
//   const dayName = i18n.t(weekdayName);
//
//   return (
//     <div className={className} title={String(weekdayName)}>
//       {dayName.slice(0, 3)}
//     </div>
//   );
// }

const notAvailableDate = (date: CalendarType, props: CalendarType) => {
  return (
    <div className="not-available">
      <div className="date">{date}</div>
    </div>
  );
}

const renderDays = (day: CalendarType, props: CalendarType) => {
  const date = day.getDate();
  const notAvailable = props.notAvailable;

  const newDay = new Date(String(day));

  if (notAvailable && notAvailable.length) {
    for (const x of notAvailable) {
      if (moment(moment(newDay).format('YYYY-MM-DD')).isSame(x)) {
        return notAvailableDate(date, props);
      }
    }
  }

  if (moment(newDay).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
    return (
      <div>
        <div className="date">{date}</div>
      </div>
    );
  }

  return (
    <div className="available" onClick={() => props.selectDate ? props.selectDate(moment(newDay).format('YYYY-MM-DD')) : null }>
      <div className="date">{date}</div>
    </div>
  );
}

const CommonCalendar = (props: CalendarType) => {
  // console.log(new Date(moment().format('YYYY, MM, 1')))
  let monthStartDate = new Date(moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'));
  let startMonth = monthStartDate;

  if (props.dateFrom && props.isTo) {
    monthStartDate = new Date(moment(props.dateFrom, 'YYYY-MM-DD').format('YYYY-MM-DD'));
  }

  if (!props.isTo && props.dateFrom) {
    startMonth = new Date(moment(props.dateFrom, 'YYYY-MM-DD').format('YYYY-MM-DD'));
  }

  if (props.isTo) {
    if (props.dateFrom) {
      startMonth = new Date(moment(props.dateFrom, 'YYYY-MM-DD').format('YYYY-MM-DD'));
    }

    if (props.dateFrom && props.dateTo) {
      startMonth = new Date(moment(props.dateTo, 'YYYY-MM-DD').format('YYYY-MM-DD'));
    }
  }


  // const monthsName = [
  //   i18n.t('january'),
  //   i18n.t('february'),
  //   i18n.t('march'),
  //   i18n.t('april'),
  //   i18n.t('may'),
  //   i18n.t('june'),
  //   i18n.t('july'),
  //   i18n.t('august'),
  //   i18n.t('september'),
  //   i18n.t('october'),
  //   i18n.t('november'),
  //   i18n.t('december'),
  // ];
  return (
    <div className="box-calendar">
      <DayPicker
        navbarElement={navbarElement}
        firstDayOfWeek={1}
        month={startMonth}
        renderDay={(day: any) => renderDays(day, props)}
        disabledDays={[
          {
            // after: new Date(2019, 9, 1),
            before: monthStartDate,
          },
        ]}
        localeUtils={MomentLocaleUtils}
        locale={i18n.locale.replace('se', 'sv').replace('no', 'nn')}
      />
    </div>
  )
}

export { CommonCalendar };
